import { BaseAPI } from './base';
import type { PaginationRequest } from '../../types/base.dto';

export interface LockFeeConfig {
  id: string | number;
  brandId: string | number;
  productQuality: string;
  purchaseChannel: string;
  amount: number;
  status?: number;
  remark?: string;
  createdAt?: string;
  updatedAt?: string;
  [key: string]: any;
}

export interface LockFeeConfigListParams extends PaginationRequest {
  brandId?: string | number;
  productQuality?: string;
  purchaseChannel?: string;
  status?: number;
}

export interface LockFeeConfigCreateParams {
  brandId: string | number;
  productQuality: string;
  purchaseChannel: string;
  amount: number;
  status?: number;
  remark?: string;
}

export interface LockFeeConfigUpdateParams extends Partial<LockFeeConfigCreateParams> {}

export class LockFeeConfigAPI extends BaseAPI<LockFeeConfig> {
  constructor() {
    super('/lock-fee-configs');
  }
}

export const lockFeeConfigApi = new LockFeeConfigAPI();

export default lockFeeConfigApi;
